<app-page-header>
  @if (!isBelowIpadSize) {
  <span class="page-title">
    <span class="icon w-100" (click)="navigateBack()"
      ><i class="pi pi-angle-left"></i> Back To Document</span
    >
  </span>
  }
</app-page-header>
<div class="app-container">
  <div class="main">
    <!-- <div class="chat-header">
    <img src="assets/images/ai-agentic/sound-waves.gif" alt="sound waves">
  </div> -->
    <div class="chat-header">
      <!-- Idle -->
      @if (aiState === 'idle') {
      <div class="ai-bars idle">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      }

      <!-- Listening -->
      @if (aiState === 'listening') {
      <div class="ai-bars listening">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      }

      <!-- Speaking -->
      @if (aiState === 'speaking') {
      <div class="ai-bars speaking">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      }
    </div>

    <div class="bot-wrapper">
      <div class="caption-wrapper">
        <div class="p-4 text-center">
          <div class="mt-4 text-left">
            @for (line of transcriptLines; track line; let i = $index) {
            <p class="caption-line">
              {{ line }}
            </p>
            }
            <!-- {{liveSubtitle}} -->
            <!-- <div *ngFor="let c of caption" class="caption-line" [class.final]="c.isFinal">
          <span class="time">{{ c.timestamp | date:'HH:mm:ss' }}</span>
          <span class="text">{{ c.text }}</span>
        </div> -->
          </div>
        </div>
      </div>
      <div class="btn-actions">
        <!-- Close button -->
        <button class="icon-btn close-btn" (click)="redirectBotChat()">
          <img
            src="assets/images/ai-agentic/close.png"
            alt="close"
            style="width: 1.5rem"
          />
        </button>

        <!-- Mic toggle -->
        <button class="icon-btn mic-btn" (click)="toggleMic()">
          @if (!isMicMuted) {
          <span class="pulse-ring"></span>
          } @if (!isMicMuted) {
          <img
            src="assets/images/ai-agentic/mic.png"
            alt="mic"
            style="width: 1.5rem"
          />
          } @if (isMicMuted) {
          <img
            src="assets/images/ai-agentic/mute-red.png"
            alt="mute-mic"
            style="width: 1.5rem"
          />
          }
        </button>

        <!-- Transcript -->
        <button class="icon-btn" (click)="viewTranscriptModal()">
          <img
            src="assets/images/ai-agentic/chat.png"
            alt="chat"
            style="width: 1.5rem"
          />
        </button>
      </div>
    </div>
  </div>
  @if (isViewTranscript) {
  <div class="bot-overlay" (click)="closeTranscriptModal()">
    <div class="right-modal" (click)="$event.stopPropagation()">
      <header>
        <h3 style="font-weight: 700">Agentic AI</h3>
        <button class="close-btn" (click)="closeTranscriptModal()">✖</button>
      </header>
      @if (aiBotTransData.length > 0) {
      <div class="chat-wrapper">
        @for (item of aiBotTransData; track i($index, item); let even = $even) {
        <app-voice-transcript
          [voiceTData]="item"
          [index]="i"
        ></app-voice-transcript>
        }
      </div>
      }
    </div>
  </div>
  }
</div>
